var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex-between" },
      [
        _c("div", { staticClass: "title-16" }, [_vm._v("流程列表")]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
            on: { click: _vm.openBox },
          },
          [_vm._v("新建流程")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex mb10 h32" }, [
      _c("div", { staticClass: "inTotal" }, [
        _vm._v("共 " + _vm._s(_vm.tableData.length) + " 项"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ml14" },
        [
          _c("el-input", {
            staticClass: "input",
            staticStyle: { width: "250px" },
            attrs: {
              "prefix-icon": "el-icon-search",
              size: "small",
              placeholder: "请输入关键字",
              clearable: "",
            },
            on: { change: _vm.getList },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.getList($event)
              },
            },
            model: {
              value: _vm.where.name,
              callback: function ($$v) {
                _vm.$set(_vm.where, "name", $$v)
              },
              expression: "where.name",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "table-box",
      },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { "row-key": "id", data: _vm.tableData, height: _vm.height },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "name",
                label: _vm.$t("business.businessType"),
                "min-width": "230",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "flex" }, [
                        _c(
                          "div",
                          {
                            staticClass: "selIcon",
                            style: { backgroundColor: scope.row.color },
                          },
                          [
                            _c("i", {
                              staticClass: "icon iconfont",
                              class: scope.row.icon,
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml10" }, [
                          _vm._v(_vm._s(scope.row.name || "--")),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "refuse",
                label: "发起人范围",
                "min-width": "200",
                "show-overflow-tooltip": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", [
                        _vm._v(_vm._s(row.userList ? row.userList : "所有人")),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "info",
                label: "审批说明",
                "min-width": "200",
                "show-overflow-tooltip": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n          " + _vm._s(row.info || "--") + "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "updated_at",
                label: "更新时间",
                "min-width": "140",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "状态", width: "160" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-switch", {
                        attrs: {
                          "active-text": _vm.$t("hr.open"),
                          "inactive-text": _vm.$t("hr.close"),
                          "active-value": 1,
                          "inactive-value": 0,
                          width: 60,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handleStatus(scope.row)
                          },
                        },
                        model: {
                          value: scope.row.status,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "status", $$v)
                          },
                          expression: "scope.row.status",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "address",
                label: "操作",
                fixed: "right",
                width: "170",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.editFn(scope.row)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteFn(scope.row)
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-fixed" },
          [
            _c("el-pagination", {
              attrs: {
                "page-size": _vm.where.limit,
                "current-page": _vm.where.page,
                "page-sizes": [15, 20, 30],
                layout: "total,sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.pageChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }